import { getTrans } from '@/utils/tools';
import { GetMsgResCode } from '@/utils/constants';
import { addAgentTip } from '@/utils/agent';
import { handleTerminalConfict } from '../handleTerminalConfict';

const ERROR_HANDLER = {
  // 多端冲突
  [GetMsgResCode.MULTI_TERMINAL_CONFLICT]: () => {
    handleTerminalConfict();
  },
  // 无网络 No network connection
  [GetMsgResCode.NETWORK_ERROR]: () => {
    addAgentTip(getTrans('agent_error_network_error'));
  },
  // 服务器宕机 Server downtime
  [GetMsgResCode.SERVER_ERROR]: () => {
    addAgentTip(getTrans('agent_error_server_error'));
  },
  // 服务器过慢，超时 Server response/timeout
  [GetMsgResCode.TIMEOUT_ERROR]: () => {
    addAgentTip(getTrans('agent_error_timeout'));
  },
};

export default ERROR_HANDLER;
